module.exports = __webpack_public_path__ + "img/circle.1541da91.svg";